import { render, staticRenderFns } from "./AreaListAccordion.vue?vue&type=template&id=a6fceeb0&scoped=true&"
import script from "./AreaListAccordion.vue?vue&type=script&lang=js&"
export * from "./AreaListAccordion.vue?vue&type=script&lang=js&"
import style0 from "./AreaListAccordion.vue?vue&type=style&index=0&id=a6fceeb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fceeb0",
  null
  
)

export default component.exports